export const ControlInputFieldLabels = {
  title: 'Title',
  description: 'Description',
  controlVerification: 'Control Verification',
  attachment: 'Attachments',
  assignTask: 'Assign Task',
  assignCauses: 'Assign Causes',
  assignActions: 'Assign Actions',
  assignDesignOutputs: 'Assign Design Outputs',
  assignVerifications: 'Assign Verifications',
  assignValidations: 'Assign Validations',
  taskFiles: 'Document References'
} as const;

export type HazardControlInputField = keyof typeof ControlInputFieldLabels;

export const ControlInputFields: HazardControlInputField[] = Object.keys(
  ControlInputFieldLabels
) as HazardControlInputField[];
